import React from 'react';

const DashbordCart = () => {
  return (
    <div>
      <img className='w-full' src={`https://media.istockphoto.com/id/1332536904/photo/medical-hud-interface-of-the-future-a-system-for-managing-medical-data-obtained-by-scanning.jpg?s=612x612&w=0&k=20&c=KalIzyiG_SbXYovhbT1Z-J6Z3vMVIIIGy8hbx7ixpyQ=`} alt="" />
    </div>
  );
};

export default DashbordCart;